import {OrderDestination} from "app/orders/models/OrderRecord"

export class IosOrderDestinations {

    private constructor(
        public readonly placeOn: OrderDestination,
        public readonly rootDestinations: ReadonlyArray<OrderDestination>
    ) {
    }

    public static single(destination: OrderDestination): IosOrderDestinations {
        return new IosOrderDestinations(destination, [destination])
    }

    public static of(placedOn: OrderDestination, ...rootDestinations: ReadonlyArray<OrderDestination>) {
        return new IosOrderDestinations(placedOn, rootDestinations)
    }
}